import DatePickerComponent from './DatePicker';
import MultiPickerComponent from './MultiPicker/MultiPicker';
import PhonePickerComponent from './PhonePicker';
import TextPickerComponent from './TextPicker';

export const DatePicker = DatePickerComponent;
export const MultiPicker = MultiPickerComponent;
export const PhonePicker = PhonePickerComponent;
export const TextPicker = TextPickerComponent;
